import { render, staticRenderFns } from "./ProductionUnit.vue?vue&type=template&id=56dcd054&lang=pug&"
import script from "./ProductionUnit.vue?vue&type=script&lang=js&"
export * from "./ProductionUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports